/**
 * Bug #452
 * @Author Santhosh Kumar
 * @Date 21 June 2021
 */
import axios from "axios";
import { API_PATIENT_CCDA_VIEW, API_QR_CODE_GENERATE, API_QR_CODE_VALIDATOR, API_GET_USER_DEMOGRPHICS, API_SAVE_USER_DEMOGRPHICS, API_INSURANCE_SEARCH, API_INSURANCE_SAVE, API_INSURANCE_DELETE, API_GET_PATIENT_INSURANCE, API_LIST_APPOINTMENTS_VIRTUAL_CHECKIN, API_UPDATE_APPOINTMENT_STATUS, API_LIST_PATIENTFORMS, API_SAVE_USER_PROFILE_IMAGE, API_GET_DEPENDANT_MAP, API_UPLOAD_DOCUMENT, API_GET_DOCUMENT, API_GET_DOWNLOAD_DOCUMENT, API_DELETE_DOCUMENT, API_DELETE_PATIENT_FORMS, API_LIST_NOTIFICATION } from 'api/endpoint';/*CR #449 @Author Jithin Kuriakose @Date 25 June 2021 */

const getCCDAView = (data) => {
  return axios.post(API_PATIENT_CCDA_VIEW, data)
};

/*** End ***/
/*
    CR #449
    @Author Jithin Kuriakose
    @Date 25 June 2021
*/
const generatePatientQrCode = () => {
  return axios.get(API_QR_CODE_GENERATE)
};

const validatePatientQrCode = (data) => {
  return axios.post(API_QR_CODE_VALIDATOR, data)
};
/*** End ***/

/**
 * Bug #438
 * @Author Anupama P
 * @Date 23 June 2021
 */
const getUserDemographics = (data = {}) => {
  return axios.get(API_GET_USER_DEMOGRPHICS, { params: { ...data } });
}

const saveUserDemographics = (params) => {
  return axios.post(API_SAVE_USER_DEMOGRPHICS, params);
}

/**
 * Bug #503
 * @Author Aby Joseph
 * @Date 19 July 2021
 */
const searchInsurance = (data) => {

  return axios.get(API_INSURANCE_SEARCH, {
    params: {
      searchKey: data,
      pageNo: 0,
      pageSize: 15
    }
  });
}

const savePatientInsurance = (data) => {
  return axios.post(API_INSURANCE_SAVE, data);
}

const deletePatientInsurance = (id, status) => {
  return axios.delete(API_INSURANCE_DELETE, {
    params: {
      id: id,
      active: status /** Bug#743 @Author: Linda Susan Raju @Date: 01 Feb 2022*/
    }
  });
}

const getPatientInsurance = (status) => {
  return axios.get(API_GET_PATIENT_INSURANCE, {
    params: {
      active: status /** Bug#743 @Author: Linda Susan Raju @Date: 01 Feb 2022*/
    }
  });
}
/*** End ***/

/**
  * Bug #566
  * @Author Aby Joseph
  * @Date 26 August 2021
*/
const getPatientAppointmentsForCheckin = (guid) => {
  return axios.get(API_LIST_APPOINTMENTS_VIRTUAL_CHECKIN, { params: { guid: guid } })
};

/**
  * Bug #604
  * @Author Liya Baby
  * @Date 06 Sept 2021
*/
export const updateAppointments = (apptId, apptStatus) => {

  return axios.post(API_UPDATE_APPOINTMENT_STATUS, {

    apptId: apptId,
    apptStatus: apptStatus,

  });
};

/**
  * Bug #606
  * @Author Liya Baby
  * @Date 06 Sept 2021
*/
const listPatientForms = (pageNo) => {
  return axios.get(API_LIST_PATIENTFORMS, {
    params: {/** Bug#698 @Author: Linda Susan Raju @Date: 04 Jan 2022*/
      pageNo: pageNo,
      pageSize: 10
    }
  })
};

/** Bug#623 @Author: Linda Susan Raju @Date: 05 Oct 2021*/
const saveUserProfileImage = (id, userImage) => {
  return axios.post(API_SAVE_USER_PROFILE_IMAGE, {
    id: id,
    userProfileImage: userImage
  });
}

/**
 * Bug #664
 * @Author Aby Joseph
 * @Date 09 Dec 2021
 */
const getDependantMap = () => {
  return axios.get(API_GET_DEPENDANT_MAP, { params: {} });
}

/** Bug#698 @Author: Linda Susan Raju @Date: 30 Dec 2021*/
const uploadDocuments = (formdata, config) => {
  return axios.post(API_UPLOAD_DOCUMENT, formdata, config);
};

const getDocumentList = (category, pageNo, pageSize) => {
  return axios.get(API_GET_DOCUMENT, {
    params: {
      category: category,
      pageNo: pageNo,
      pageSize: pageSize
    }
  })
};

const getDocumentDownload = (id) => {
  return axios.get(API_GET_DOWNLOAD_DOCUMENT, {
    params: {
      id: id,
    }
  })
};

/** Bug#698 @Author: Linda Susan Raju @Date: 10 Jan 2022*/
const deleteIdOtherDocuments = (id) => {
  return axios.delete(API_DELETE_DOCUMENT, { params: { id: id } });
}

const deletePatientForms = (id) => {
  return axios.delete(API_DELETE_PATIENT_FORMS, { params: { id: id } });
}
/** Bug #770 Midhila Velayudhan Date:05 march 2022 */
const getNotificationList=(pageNo, pageSize,readStatus)=>{
  return axios.get(API_LIST_NOTIFICATION, {
    params: {
      pageNo: pageNo,
      pageSize: 10,
      readStatus : readStatus
    }
  })
};

export {
  getUserDemographics,
  saveUserDemographics,
  validatePatientQrCode,
  generatePatientQrCode,
  getCCDAView,
  searchInsurance,
  savePatientInsurance,
  deletePatientInsurance,
  getPatientInsurance,
  getPatientAppointmentsForCheckin,
  listPatientForms,
  saveUserProfileImage,
  getDependantMap,
  uploadDocuments,
  getDocumentList,
  getDocumentDownload,
  deleteIdOtherDocuments,
  deletePatientForms,
  getNotificationList,
  
}
/*** End ***/